import { Injectable } from '@angular/core';
import { UserInit } from '@features/user-init/user-init.actions';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { HttpError, UserFlags } from '@rd/types';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { UserFlagsApiService } from '../../api/user-flags-api.service';
import {
  LoadUserFlags,
  LoadUserFlagsFail,
  LoadUserFlagsSuccess,
} from '../actions/user-flags.actions';

@Injectable()
export class UserFlagsEffects {
  constructor(
    private actions$: Actions,
    private store: Store,
    private userFlagApiService: UserFlagsApiService,
  ) {}

  loadUserFlags$ = createEffect(() =>
    this.actions$.pipe(
      ofType(LoadUserFlags),
      switchMap(() => {
        return this.userFlagApiService.getUserFlags().pipe(
          map((userFlagsResponse: UserFlags) => {
            return LoadUserFlagsSuccess({
              payload: userFlagsResponse.userFlags,
            });
          }),
          catchError((error: HttpError) =>
            of(LoadUserFlagsFail({ payload: error })),
          ),
        );
      }),
    ),
  );

  pullUserFlagsOnUserLogin$ = createEffect(() =>
    this.actions$.pipe(
      ofType(UserInit),
      map(() => LoadUserFlags()),
    ),
  );
}
